import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a3cc8a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification" }
const _hoisted_2 = {
  key: 0,
  class: "new"
}
const _hoisted_3 = {
  key: 0,
  class: "badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    (_ctx.hasNewNotifications)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_ctx.newNotificationsCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.newNotificationsCount), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}